import { render, staticRenderFns } from "./SpeechText.vue?vue&type=template&id=31b088a4&"
import script from "./SpeechText.vue?vue&type=script&lang=js&"
export * from "./SpeechText.vue?vue&type=script&lang=js&"
import style0 from "./SpeechText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports